import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const BurundiFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_14330'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_14330)'>
				<rect
					width='20'
					height='14'
					fill='#E4233B'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 0L8.57143 7L0 14V0Z'
					fill='#34CD4E'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M20 0L11.4286 7L20 14V0Z'
					fill='#34CD4E'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M12.1165 4.47559C11.541 4.01177 10.804 3.73329 10.0007 3.73329C9.1974 3.73329 8.46046 4.01177 7.88493 4.47559L-0.915339 -1.34155L-1.98047 0.205984L6.81911 6.02267C6.72052 6.33125 6.66738 6.65952 6.66738 6.99996C6.66738 7.3404 6.72052 7.66867 6.81911 7.97725L-1.98047 13.7939L-0.915339 15.3415L7.88493 9.52433C8.46046 9.98815 9.1974 10.2666 10.0007 10.2666C10.804 10.2666 11.541 9.98815 12.1165 9.52433L20.9168 15.3415L21.9819 13.7939L13.1823 7.97725C13.2809 7.66867 13.334 7.3404 13.334 6.99996C13.334 6.65952 13.2809 6.33125 13.1823 6.02267L21.9819 0.205985L20.9168 -1.34155L12.1165 4.47559Z'
					fill='white'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M10.0004 6.0667L9.32701 6.26L9.52425 5.60003L9.32701 4.94006L10.0004 5.13336L10.6739 4.94006L10.4766 5.60003L10.6739 6.26L10.0004 6.0667ZM8.57187 8.40003L7.89844 8.59333L8.09568 7.93336L7.89844 7.2734L8.57187 7.4667L9.24531 7.2734L9.04806 7.93336L9.24531 8.59333L8.57187 8.40003ZM10.7556 8.59333L11.429 8.40003L12.1025 8.59333L11.9052 7.93336L12.1025 7.2734L11.429 7.4667L10.7556 7.2734L10.9528 7.93336L10.7556 8.59333Z'
					fill='#DF2239'
				/>
			</g>
		</svg>
	);
};

export default BurundiFlagIcon;
